<div
    *ngIf="(errorMessage !== '')"
    class="ibe-validation-message error"
>
    {{ errorMessage }}
</div>
